import type { FlagId } from '@trello/analytics-types';
import { intl } from '@trello/i18n';
import { showFlag, type ShowFlagArgs } from '@trello/nachos/experimental-flags';

export const showFeedbackFlag = ({
  id,
  ...rest
}: Partial<
  Omit<ShowFlagArgs, 'actions' | 'appearance' | 'id' | 'isAutoDismiss'>
> & {
  id: FlagId;
}): void => {
  showFlag({
    id,
    appearance: 'success',
    description: intl.formatMessage({
      id: 'templates.feedback_collector.flag-success-description',
      defaultMessage:
        'Your valuable feedback helps us continually improve our products.',
      description: 'Description shown in the feedback success flag.',
    }),
    title: intl.formatMessage({
      id: 'templates.feedback_collector.flag-success-title',
      defaultMessage: 'Thanks!',
      description: 'Title shown in the feedback success flag.',
    }),
    ...rest,
  });
};
